// notification styles 
const successStyle = {
  background: "rgba(0,255,0,0.3)",
  color: "#333",
  fontWeight: "600"
}

const errorStyle = {
  border: "1px solid red",
  background: "rgba(255,0,0,0.3)",
  color: "#333",
  fontWeight: "600"
}
export default { successStyle, errorStyle }